import React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '../../ui/tooltip';
import type { Citation, ConversationCallbacks } from '../types';

interface CitationBlockProps {
  citations: Citation[];
  onCitationClick?: ConversationCallbacks['onCitationClick'];
}

export const CitationBlock = ({ citations, onCitationClick }: CitationBlockProps) => {
  return (
    <span className="inline-flex flex-wrap gap-1">
      {citations.map((citation) => (
        <CitationBadge key={citation.id} citation={citation} onClick={onCitationClick} />
      ))}
    </span>
  );
};

interface CitationBadgeProps {
  citation: Citation;
  onClick?: ConversationCallbacks['onCitationClick'];
}

const CitationBadge = ({ citation, onClick }: CitationBadgeProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary/10 text-xs font-medium text-primary hover:bg-primary/20 transition-colors"
          onClick={() => onClick?.(citation)}
        >
          {citation.index}
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs">
        <p className="text-sm font-medium">{citation.title}</p>
        <p className="text-xs text-muted-foreground truncate">{citation.url}</p>
      </TooltipContent>
    </Tooltip>
  );
};
